export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название', trigger: 'blur' },
    ],
};